import React from "react";
import { CheckIcon } from "../Enrolment/Certificate/Icons";

// The "Verified by 42courses" card. Shared by the public verification page and
// the learner's own certificate page so the two never drift apart; the facts
// themselves differ, so each page passes its own.

export interface CertificateFact {
  label: string;
  value: string;
  // Credential IDs are read out and typed in, so they get the tabular
  // monospace treatment.
  mono?: boolean;
}

interface Props {
  facts: CertificateFact[];
  className?: string;
}

const CertificateFacts: React.FC<Props> = ({ facts, className = "" }) => {
  const shown = facts.filter((fact) => fact.value);

  if (!shown.length) return null;

  return (
    <div className={`cert-verify ${className}`.trim()}>
      <div className="cert-verify__card">
        <div className="cert-verify__top">
          <span className="cert-verify__tick" aria-hidden="true">
            <CheckIcon />
          </span>
          <div>
            <h3>Verified by 42courses</h3>
            <p>This certificate was issued by 42courses and is genuine.</p>
          </div>
        </div>
        {/* Column count follows the number of facts, so a course with no CPD
            figure recorded gives three even columns rather than three columns
            and a hole. */}
        <div
          className="cert-verify__grid"
          style={{ "--fact-count": shown.length } as React.CSSProperties}
        >
          {shown.map((fact) => (
            <div className="cert-fact" key={fact.label}>
              <div className="k">{fact.label}</div>
              <div className={`v${fact.mono ? " v--mono" : ""}`}>{fact.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CertificateFacts;
